import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Layout from '../components/layout/Layout';
import ProtectedRoute from './ProtectedRoute';

// Import the real LoginPage
import LoginPage from '../pages/Auth/LoginPage';
import Dashboard from '../pages/Dashboard/Dashboard';
import SuperAdminDashboard from '../pages/Dashboard/SuperAdminDashboard';
import CustomerList from '../pages/Customers/CustomerList';
import AddCustomer from '../pages/Customers/AddCustomer';
import EditCustomer from '../pages/Customers/EditCustomer';
import CustomerDetail from '../pages/Customers/CustomerDetail';
import InvoiceList from '../pages/Invoices/InvoiceList';
import AddInvoice from '../pages/Invoices/AddInvoice';
import EditInvoice from '../pages/Invoices/EditInvoice';
import InvoiceDetail from '../pages/Invoices/InvoiceDetail';
// import ReceivedAmountForm from '../pages/ReceivedAmount/ReceivedAmountForm';
import ReceivedAmountPage from '../pages/ReceivedAmount';
import EmployeeList from '../pages/Employees/EmployeeList';
import SettingsPage from '../pages/Settings/SettingsPage';
import DocumentsPage from '../pages/Documents/DocumentsPage';
import AccountHeadList from '../pages/AccountHead/AccountHeadList';
import DocumentsStoragePage from '../pages/Documents/DocumentsStoragePage';
import VerifyTfaPage from '../pages/Auth/VerifyTfaPage';
import ReportsPage from '../pages/Reports/ReportsPage';
import PendingAmountList from '../pages/Dashboard/PendingAmountList';
import OverdueInvoiceList from '../pages/Dashboard/OverdueInvoiceList';
import DataSheetList from '../pages/DataSheet/DataSheetList';
import DataSheetDetail from '../pages/DataSheet/DataSheetDetail';
import BalanceReportDetailPage from '../pages/Reports/BalanceReportDetail';
import InstructionManagement from '../pages/Admin/InstructionManagement';
import CompanyManagement from '../pages/Admin/CompanyManagement';
import SuperAdminSettings from '../pages/Admin/SuperAdminSettings';
import ExtraAmountList from '../pages/Dashboard/ExtraAmountList';
import AdsPage from '../pages/Ads/AdsPage';
import CustomerLoginPage from '../pages/Auth/CustomerLoginPage';
import CustomerDetails from '../pages/Customers/CustomerDetails';
import DocumentsCloudStorage from '../pages/Documents/DocumentsCloudStorage';
const EmployeeForm = () => <div>Employee Form Page</div>;
const EmployeeDetails = () => <div>Employee Details Page</div>;
// const ReceivedAmountEntry = () => <div>Received Amount Entry Page</div>;
const ReceivedAmountHistory = () => <div>Received Amount History Page</div>;

const AppRoutes: React.FC = () => {
  const { auth } = useAuth();

  // If still loading, show loading screen
  if (auth.isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Loading...
      </div>
    );
  }

  // Choose the appropriate dashboard component based on user role
  const DashboardComponent = auth.user?.role === 'super_admin' ? SuperAdminDashboard : Dashboard;

  return (
    <Router>
      <Routes>
        {/* Public routes */}

        <Route 
  path="/customer-login"
  element={
      <CustomerLoginPage />
  }
/>


        <Route 
          path="/login" 
          element={
            <LoginPage />
          } 
        />

        {/* Protected routes with layout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <DashboardComponent />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="/dashboard/pending-amount" element={ <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
              <PendingAmountList />
              </Layout>
            </ProtectedRoute>} />

        <Route path="/dashboard/extra-amount" element={ <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
              <ExtraAmountList />
              </Layout>
            </ProtectedRoute>} />

            
        <Route path="/dashboard/overdue-invoices" element={<ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
              <OverdueInvoiceList />
              </Layout>
            </ProtectedRoute>} />

        {/* Customer routes */}
        <Route
          path="/customers"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <CustomerList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/new"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <AddCustomer />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/:id"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <CustomerDetail />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/balance"
          element={
            <CustomerDetails />
          }
        />
        <Route
          path="/customers/:id/edit"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <EditCustomer />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Invoice routes */}
        <Route
          path="/invoices"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <InvoiceList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoices/new"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <AddInvoice />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoices/:id"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <InvoiceDetail />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoices/:id/edit"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <EditInvoice />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Data Sheet routes */}
        <Route
          path="/data-sheets"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <DataSheetList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/data-sheets/:id"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <DataSheetDetail />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Employee routes (admin only) */}
        <Route
          path="/employees"
          element={
            <ProtectedRoute requiredRole="admin" >
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <EmployeeList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/employees/new"
          element={
            <ProtectedRoute requiredRole="admin">
              <Layout role={auth.user?.role}>
                <EmployeeForm />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/employees/:id"
          element={
            <ProtectedRoute requiredRole="admin">
              <Layout role={auth.user?.role}>
                <EmployeeDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/employees/:id/edit"
          element={
            <ProtectedRoute requiredRole="admin">
              <Layout role={auth.user?.role}>
                <EmployeeForm />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Received Amount routes */}
        <Route
          path="/received-amount"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <ReceivedAmountPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/received-amount/history"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <ReceivedAmountHistory />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Settings route (admin only) */}
        <Route
          path="/account-head"
          element={
            <ProtectedRoute requiredRole="admin">
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <AccountHeadList />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Settings route (admin only) */}
        <Route
          path="/settings"
          element={
            <ProtectedRoute requiredRole="admin">
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <SettingsPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Instruction Management route (admin only) */}
        <Route
          path="/instructions"
          element={
            <ProtectedRoute requiredRole="admin">
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <InstructionManagement />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Company Management route (super admin only) */}
        <Route
          path="/companies"
          element={
            <ProtectedRoute requiredRole="super_admin">
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <CompanyManagement />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Super Admin Settings route (super admin only) */}
        <Route
          path="/settings-super-admin"
          element={
            <ProtectedRoute requiredRole="super_admin">
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <SuperAdminSettings />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Super Admin Settings route (super admin only) */}
        <Route
          path="/ads"
          element={
            <ProtectedRoute requiredRole="super_admin">
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <AdsPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Settings route (admin only) */}
        <Route
          path="/documents"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <DocumentsPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/document-storage"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <DocumentsStoragePage />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* TFA verification route */}
        <Route path="/verify-tfa" element={<VerifyTfaPage />} />

        {/* Reports route */}
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <ReportsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/balance/:customerId"
          element={
            <ProtectedRoute>
              <Layout role={auth.user?.role} permissions={auth.user?.permissions}>
                <BalanceReportDetailPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Default redirect */}
        <Route 
          path="/" 
          element={<Navigate to="/dashboard" replace />} 
        />

      <Route
          path="/cloud-storage"
          element={
            <ProtectedRoute cloudOnly>
              <Layout role={auth.user?.role} permissions={auth.user?.is_cloud_active}>
                <DocumentsCloudStorage />
              </Layout>
            </ProtectedRoute>
          }
        />
        
        {/* 404 route */}
        <Route 
          path="*" 
          element={
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: '100vh',
              flexDirection: 'column'
            }}>
              <h1>404 - Page Not Found</h1>
              <p>The page you're looking for doesn't exist.</p>
            </div>
          } 
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes; 